module.exports = __webpack_public_path__ + "static/img/tabsbg04.f17e269d.png";